import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {ProjectVersion} from "./projectVersionDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";
import {ProjectVersionMaterial} from "./projectVersionMaterialDomain";
import {ProjectVersionRoom} from "./projectVersionRoomDomain";


@entityConfig()
export default class ProjectVersionDoor extends DomainAncestor {

  @observable doorId : number;
  @observable projectVersion : ProjectVersion;
  @observable name : string;
  @observable roomFrom : LovItem<ProjectVersionRoom>;
  @observable roomTo : LovItem<ProjectVersionRoom>;
  @observable reachableOnlyByLadder : boolean;
  @observable doorType : LovItem<DOORSECURITYTYPE>;
  @observable height : number;
  @observable width : number;
  @observable threshold : boolean;
  @observable frameMaterial : LovItem<ProjectVersionMaterial>;
  @observable frameMaterialMass : number;
  @observable leafMaterial1 : LovItem<ProjectVersionMaterial>;
  @observable leafMaterial1Mass : number;
  @observable leafMaterial2 : LovItem<ProjectVersionMaterial>;
  @observable leafMaterial2Mass : number;
  @observable leafMaterial3 : LovItem<ProjectVersionMaterial>;
  @observable leafMaterial3Mass : number;
  @observable remoteControl : boolean;
  @observable entranceAtLeast1250mmWide : boolean;
  @observable suitableForHandicapped : boolean;
  @observable protectedAgainstWheelchair : boolean;
  @observable lockNotMoreThen1000mmAbove : boolean;
  @observable handleNotMoreThen1000mmAbove : boolean;
  @observable markedContrastingly : boolean;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.doorId;
  }

  public setId(id: ID): void {
    this.doorId = <number>id;
  }

}

export enum DOORSECURITYTYPE {
  FIRST = "1",
  SECOND = "2",
  THIRD = "3",
  FOURTH = "4",
  FIFTH = "5",
  SIXTH = "6"
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionDoorDomain.ts